import { CustomTooltip, UIText2 } from '@cian/ui-kit';
import * as React from 'react';

interface IBookingCalendarTooltipProps {
  anchorRef: React.RefObject<HTMLElement>;
  open: boolean;
  error: string;
}

export const BookingCalendarTooltip = ({ open, error, anchorRef }: IBookingCalendarTooltipProps) => {
  return (
    <CustomTooltip
      maxWidth={155}
      onClose={() => {}}
      anchorRef={anchorRef}
      open={open}
      content={<UIText2 color="white_100">{error}</UIText2>}
      placement="top-end"
      theme="black"
      size="M"
      flip
      arrow
      portal
      preventOverflow
    />
  );
};
